<template lang="pug">
div
  app-main-menu

  app-main-content
    .c-settings-page
      section.c-settings-page__header
        h1.c-settings-page__heading Settings
        p.c-settings-page__subtitle Manage your account settings

      section.c-settings-card
        h2.c-settings-card__title Change Password
        change-password
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ChangePassword from './ChangePassword.vue';
import AppMainMenu from '@/components/AppMainMenu.vue';

export default defineComponent({
  name: 'Settings',
  components: {
    ChangePassword,
    AppMainMenu,
  },
});
</script>

<style lang="scss" scoped>
@import '@/views/manage-users-and-organizations/crm-list';

.c-settings-page {
  @include crm-page;
  max-width: 1200px;
  margin: 0 auto;

  &__header {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  &__heading {
    font-size: 1.875rem;
    font-weight: 600;
    line-height: 2.25rem;
    color: $foreground;
    margin: 0;
  }

  &__subtitle {
    font-size: 1rem;
    line-height: 1.5rem;
    color: $gray-600;
    margin: 0;
  }
}

.c-settings-card {
  @include crm-card;
  padding: 1.5rem;

  &__title {
    font-size: 1.125rem;
    font-weight: 600;
    color: $foreground;
    margin: 0 0 1.5rem;
  }
}

@media (max-width: 768px) {
  .c-settings-page {
    padding: 1.5rem;
  }
}

@media (max-width: 480px) {
  .c-settings-page {
    padding: 1rem;
  }
}
</style>
